'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withConnectedTab from 'DesignManagerIde/components/shared/hoc/withConnectedTab';
import withConnectedTabLabel from 'DesignManagerIde/components/shared/hoc/withConnectedTabLabel';
import TabTitle from 'DesignManagerIde/components/tabs/TabTitle';
import { tabDragSource, tabDropTarget } from 'DesignManagerIde/components/dnd/TabDragDrop';
import Small from 'UIComponents/elements/Small';
import castToUITab from 'DesignManagerIde/components/shared/hoc/castToUITab';
import { compose } from 'redux';
import DraggableUIRouterTab from './DraggableUIRouterTab';

class Tab extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      tooltipOpen: false
    };

    this.onMouseEnter = () => {
      const timer = this.__hoverTimer;

      if (!timer) {
        this.__hoverTimer = setTimeout(() => {
          this.setState({
            tooltipOpen: true
          });
        }, 2000);
      }
    };

    this.onMouseLeave = () => {
      const timer = this.__hoverTimer;

      if (timer) {
        clearTimeout(timer);
        this.__hoverTimer = null;

        if (this.state.tooltipOpen) {
          this.setState({
            tooltipOpen: false
          });
        }
      }
    };
  }

  componentWillUnmount() {
    const timer = this.__hoverTimer;
    if (timer) clearTimeout(timer);
  }

  renderTitle() {
    const {
      tabId,
      onClose,
      iconName,
      hasBufferedChanges,
      label,
      folderPath,
      isLocked,
      onPinClick
    } = this.props;
    return /*#__PURE__*/_jsx(TabTitle, {
      closable: true,
      iconName: iconName,
      isLocked: isLocked
      /* TODO: Re-enable this once tab pinning is fully implemented */
      ,
      isPinned: false,
      onClose: onClose,
      tabId: tabId,
      hasBufferedChanges: hasBufferedChanges,
      label: label,
      folderPath: folderPath,
      onPinClick: onPinClick
    });
  }

  renderTooltip() {
    const {
      folderPath
    } = this.props;
    if (!folderPath) return null;
    return /*#__PURE__*/_jsx(Small, {
      children: folderPath
    });
  }

  render() {
    const {
      tabId,
      pathName,
      isActive,
      isOver,
      connectDragSource,
      connectDropTarget,
      onContextMenu,
      use,
      assetParentThemeFolderId
    } = this.props;
    const renderedTitle = this.renderTitle();
    const renderedTooltip = this.renderTooltip();
    const className = classNames('file-tab', isOver && 'is--over', isActive && 'is--active');
    const to = assetParentThemeFolderId ? `${pathName}?tfid=${assetParentThemeFolderId}` : pathName;
    return /*#__PURE__*/_jsx(DraggableUIRouterTab, {
      onContextMenu: onContextMenu,
      connectDragSource: connectDragSource,
      connectDropTarget: connectDropTarget,
      className: className,
      active: isActive,
      tabId: `${tabId}`,
      title: renderedTitle,
      to: to,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onDragStart: this.onMouseLeave,
      tooltip: renderedTooltip,
      tooltipProps: {
        open: this.state.tooltipOpen
      },
      use: use
    });
  }

}

Tab.propTypes = {
  onContextMenu: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  tabId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  iconName: PropTypes.string,
  pathName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onPinClick: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  folderPath: PropTypes.string,
  hasBufferedChanges: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
  isLocked: PropTypes.bool.isRequired,
  use: PropTypes.string.isRequired,
  assetParentThemeFolderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default compose(castToUITab, withConnectedTab, withConnectedTabLabel, tabDragSource, tabDropTarget)(Tab);